const getters = {
    getUserData: state => state.user.userData,
    getNavRoutes: state => state.permission.navRoutes,
    getAddRoutes: state => state.permission.addRoute
}
export default getters
